import React, { useState, useContext } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import Box from '@material-ui/core/Box'
import Button from '@material-ui/core/Button'
import Card from '@material-ui/core/Card'
import CardHeader from '@material-ui/core/CardHeader'
import Typography from '@material-ui/core/Typography'
import BootstrapTable from 'react-bootstrap-table-next'
import Grid from '@material-ui/core/Grid'
import Loader from 'components/general/Loader'
import { onError } from 'config/lib/errorLib'
import filterFactory, { textFilter, selectFilter, numberFilter } from 'react-bootstrap-table2-filter'
import { Storage } from 'aws-amplify'
import { stringToHex } from 'config/helpers/Helpers'
import axios from 'axios'
import config from 'config/api/Config'
import ProviderAPI from 'config/api/ProviderAPI'
import { NotificationManager } from 'react-notifications'
import componentStyles from 'assets/theme/views/admin/react-bs-table.js'
import moment from 'moment'

const useStyles = makeStyles(componentStyles)

function PaymentsTable(props) {
    const classes = { ...useStyles() }
    const paymentApi = new ProviderAPI()

    const [payingId, setPayingId] = useState(null)

    async function payInvoice(payment) {
        setPayingId(payment.date)
        try {
            const result = await paymentApi.makePaymentExisting(payment)
            if (result.error) {
                NotificationManager.error(result.error)
            } else {
                NotificationManager.success('Payment successful')
                if (props.onPaymentComplete) {
                    props.onPaymentComplete(result)
                }
            }
        } catch (e) {
            onError(e)
            NotificationManager.error('Payment failed')
        }
        setPayingId(null)
    }

    async function downloadInvoice(payment) {
        //alert('This feature is in development and will be available soon')

        const fileName = payment.reference ? payment.reference : stringToHex(payment.companyId + '-' + payment.date) 
        console.log('fileName: ', fileName)

        //const info = await Auth.currentUserInfo()
        let url = await Storage.get('providers/' + props.companyId + '/' + fileName, {bucket: config.s3.BUCKET})
        console.log('url: ', url)
        try {   
            await axios.get(url)
            window.open(url)
        } catch(e) {
            onError(e)
        }
    }
    
    const [loading, setLoading] = useState(false)

    const columns = [
        {
            dataField: 'date',
            text: 'Date',
            //sort: true,
            //filter: textFilter(),
            formatter: (cell, row) => {
                return <>{row.hasOwnProperty('date') ? moment(row.date).format('DD/MM/YY') : ''}</>
            },
            //footer: 'Total'
        },
        {
            dataField: 'description',
            text: 'Description',
            sort: true,
            //filter: numberFilter(),
            formatter: (cell, row) => {
                return <>{row.hasOwnProperty('allocation') ? getDescription(row.allocation) : (row.hasOwnProperty('billingMethod') ? row.billingPeriod : '')}</>
            },
            //footer: ''
        },
        {
            dataField: 'paid',
            text: 'Payment Status',
            //sort: true,
            //filter: textFilter(),
            formatter: (cell, row) => {
                // Prefer new status string
                if (typeof row.status === 'string') {
                    // Normalize capitalization for known statuses
                    const known = ['pending','processing','invoiced','paid'];
                    if (known.includes(row.status)) {
                        return <>{row.status.charAt(0).toUpperCase() + row.status.slice(1)}</>;
                    }
                    // fallback for any other status
                    return <>{row.status}</>;
                }
                // Fallback for old invoices
                if (row.paid === true) {
                    return <>Paid</>;
                }
                if (row.invoiced === true) {
                    return <>Invoiced</>;
                }
                return <>-</>;
            },
            //footer: ''
        },
        {
            dataField: 'total',
            text: 'Total (€)',
            //sort: true,
            //filter: textFilter(),
            formatter: (cell, row) => {
                return <>{row.hasOwnProperty('total') ? '€' + row.total.toFixed(2) : ''}</>
            }
            //footer: '€' + grossSum.toFixed(2)
        },
        {
            dataField: 'amountDue',
            text: 'Due (€)',
            formatter: (cell, row) => {
                if (!row.hasOwnProperty('total')) return <>-</>;
                const amountPaid = row.amountPaid || 0;
                const amountDue = row.total - amountPaid;
                return <>{amountDue > 0 ? '€' + amountDue.toFixed(2) : '€0.00'}</>
            }
        }
    ]

    columns.push({
        dataField: 'companyId',
        text: 'Action',
        sort: false,
        formatter: (cell, row) => {
            const status = row.status || (row.paid === true ? 'paid' : (row.invoiced === true ? 'invoiced' : 'pending'));

            if (status === 'paid') {
                return (
                    <Button 
                        color='secondary'
                        variant='contained'
                        size='small'
                        onClick={() => downloadInvoice(row)}
                    >
                        Download
                    </Button>
                )
            }

            if (status === 'invoiced') {
                return <></>
            }

            // pending or other — no action
            return <></>
        }
    })

    function getDescription(allocations) {
        let description = ''

        for (let [product, values] of Object.entries(allocations)) {
            if (parseInt(values.allocation) > 0) {
                description += product + 'x' + values.allocation + ' ';
            }
        }

        return description
    }

    return (
        <Card
            classes={{
                root: classes.cardRoot,
            }}
        >
            {!loading ? (
                <>
                    <CardHeader
                        subheader={
                            <Grid
                                container
                                component={Box}
                                alignItems='center'
                                justifyContent='space-between'
                            >
                                <Grid item xs='auto'>
                                    <Box
                                        component={Typography}
                                        variant='h3'
                                        marginBottom='0!important'
                                    >
                                        Invoices
                                    </Box>
                                </Grid>
                            </Grid>
                        }
                        classes={{ root: classes.cardHeaderRoot }}
                    ></CardHeader>

                    <div className='table-container'>
                        <BootstrapTable 
                            keyField='date' 
                            data={ props.payments } 
                            columns={ columns } 
                            filter={ filterFactory() } 
                            noDataIndication={<Box>No invoices</Box>}
                        />
                    </div>
                </>
            ) : (
                <Grid container justifyContent='flex-start'>
                    <Grid item xs={12}>
                        <Box display='flex' justifyContent='center' alignItems='center' style={{height: '20vh'}}>
                            <Loader />
                        </Box>
                    </Grid>
                </Grid>
            )}
        </Card>
    );
}

export default PaymentsTable